import React from "react";
import "./surveyAdherence.css";
import AdminNavbar from "../components/AdminNavbar";
import PROkeyTable from "./PROkeyTable";

import {Col, Container, Jumbotron, Row} from "react-bootstrap";
// const query = firestore.collection("analytics/reports/reportPages");
// const [reportPages, reportPagesLoading, reportPagesError] = useCollection(query, {
// snapshotListenOptions: {includeMetadataChanges: true},
// });
// const query = firestore.collection("analytics").doc("kpi_summary")
const AnInterviewsList = (props) => {
  return (
    <>
      <AdminNavbar />
      <Jumbotron>
        <Container fluid={true}>
          <Row>
            <Col>
              <h1>Interviews 002</h1>
            </Col>
          </Row>
        </Container>
      </Jumbotron>
      {/* <AreportsListSidebar /> */}

      <Container fluid={true} style={{ backgroundColor: "white" }}>
        <div className="article">
          <p className="TitleC">interviews</p>
          <PROkeyTable tableKey={"interviews002"}></PROkeyTable>
        </div>
      </Container>
    </>
  );
};

export default AnInterviewsList;
